import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { ISocialLinks } from '@ncg/data';
import { MetaService } from '../core/meta.service';

@Component({
    selector: 'ncg-social-links',
    template: `
        <nav class="footer-bottom__navbar navbar" itemscope itemtype="https://schema.org/Organization">
            <link itemprop="url" [attr.href]="baseUrl" />
            <a
                itemprop="sameAs"
                class="footer-bottom__item"
                *ngIf="socialLinks.facebookLink && socialLinks.facebookLink.url"
                [href]="[socialLinks.facebookLink.url]"
                [attr.title]="socialLinks.facebookLink.name || 'Facebook'"
                rel="noopener"
                target="_blank">
                <svg-icon-sprite [viewBox]="'0 0 30 30'" src="facebook" [width]="'40px'" [height]="'40px'" aria-hidden="true"></svg-icon-sprite>
            </a>
            <a
                itemprop="sameAs"
                class="footer-bottom__item"
                *ngIf="socialLinks.instagramLink && socialLinks.instagramLink.url"
                [href]="[socialLinks.instagramLink.url]"
                [attr.title]="socialLinks.instagramLink.name || 'Instagram'"
                rel="noopener"
                target="_blank">
                <svg-icon-sprite [viewBox]="'0 0 30 30'" src="instagram" [width]="'40px'" [height]="'40px'" aria-hidden="true"></svg-icon-sprite>
            </a>
            <a
                itemprop="sameAs"
                class="footer-bottom__item"
                *ngIf="socialLinks.youtubeLink && socialLinks.youtubeLink.url"
                [href]="[socialLinks.youtubeLink.url]"
                [attr.title]="socialLinks.youtubeLink.name || 'YouTube'"
                rel="noopener"
                target="_blank">
                <svg-icon-sprite src="youtube" [viewBox]="'0 0 30 30'" [width]="'40px'" [height]="'40px'" aria-hidden="true"></svg-icon-sprite>
            </a>
            <a
                itemprop="sameAs"
                class="footer-bottom__item"
                *ngIf="socialLinks.linkedinLink && socialLinks.linkedinLink.url"
                [href]="[socialLinks.linkedinLink.url]"
                [attr.title]="socialLinks.linkedinLink.name || 'LinkedIn'"
                rel="noopener"
                target="_blank">
                <svg-icon-sprite src="linkedin" [viewBox]="'0 0 30 30'" [width]="'40px'" [height]="'40px'" aria-hidden="true"></svg-icon-sprite>
            </a>
        </nav>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SocialLinksComponent implements OnInit {
    @Input() socialLinks: ISocialLinks;
    baseUrl: SafeResourceUrl = '';

    constructor(
        private readonly sanitizer: DomSanitizer,
        private readonly metaService: MetaService
    ) {}

    ngOnInit() {
        this.baseUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.metaService.getBaseUrl());
    }
}
